import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import Home from '../app/page';
import '../app/globals.css';

document.documentElement.style.setProperty(
  '--font-geist-sans',
  'Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
);
document.documentElement.style.setProperty(
  '--font-geist-mono',
  '"SFMono-Regular", Consolas, "Liberation Mono", monospace',
);

const root = document.getElementById('root');

if (!root) throw new Error('Missing #root mount point');

createRoot(root).render(
  <StrictMode>
    <Home />
  </StrictMode>,
);
